import zhLocale from "element-ui/lib/locale/lang/zh-CN"; //引入element语言包
//需要转换的中文
const zh_TC = {
  message: {
    info: {
      n1: "驗證碼登錄",
      n2: "郵箱",
      n3: "請輸入郵箱",
      n4: "驗證碼",
      n5: "請輸入驗證碼",
      n6: "獲取驗證碼",
      n7: "登 錄",
      n8: "註冊",
      n9: "密碼登錄",
      n10: "密碼",
      n11: "請輸入密碼",
      n12: "郵箱錯誤",
      n13: "驗證碼已發送",
      n14: "新密碼",
      n15: "確 定",
      n16: "修改密碼",
      n17: "退出登錄",
      n18: "首頁",
      n19: "海外短信",
      n20: "短信內容",
      n21: "發送記錄",
      n22: "餘額：",
      n23: "餘額明細",
      n24: "操作前餘額",
      n25: "操作餘額",
      n26: "操作後餘額",
      n27: "業務類型",
      n28: "充值",
      n29: "消費",
      n30: "退款",
      n31: "變動類型",
      n32: "增加",
      n33: "減少",
      n34: "備註",
      n35: "操作時間",
      n36: "短信價格",
      n37: "區號",
      n38: "區域名稱",
      n39: "價格",
      n40: "激活狀態",
      n41: "可用",
      n42: "不可用",
      n43: "更新時間",
      n44: "短信列表",
      n45: "請選擇發送狀態",
      n46: "待發送",
      n47: "發送中",
      n48: "已完成",
      n49: "待確認",
      n50: "請選擇審核狀態",
      n51: "待審核",
      n52: "審核通過",
      n53: "審核拒絕",
      n54: "搜索",
      n55: "重置",
      n56: "新增",
      n57: "內容ID",
      n58: "短信內容",
      n59: "號碼總數",
      n60: "成功數",
      n61: "失敗數",
      n62: "發送狀態",
      n63: "審核",
      n64: "發送開始時間",
      n65: "發送結束時間",
      n66: "操作",
      n67: "導入號碼",
      n68: "導入完成",
      n69: "刪除",
      n70: "添加短信內容",
      n71: "請輸入內容最多500字",
      n72: "註：短信內容將直接發送給用戶，請確認無敏感信息",
      n73: "取 消",
      n74: "導入手機號碼",
      n75: "收信人",
      n76: "導入收信人",
      n77: "添加收信人",
      n78: "請下載模板文件，按照模板格式填寫手機號碼後上傳",
      n79: "下載模板",
      n80: "支持 .xlsx, .xls, .csv 格式",
      n81: "將文件拖到此處，或",
      n82: "點擊上傳",
      n83: "單次最多上傳1個文件，文件大小不超過5MB",
      n84: "請選擇",
      n85: "請輸入內容",
      n86: "添加更多號碼",
      n87: "只能上傳",
      n88: "格式的文件",
      n89: "文件大小不能超過",
      n90: "確定要刪除嗎？",
      n91: "提示",
      n92: "發送列表",
      n93: "請輸入短信內容ID",
      n94: "請選擇區號",
      n95: "請輸入接收手機號",
      n96: "請選擇狀態",
      n97: "待發送",
      n98: "發送中",
      n99: "成功",
      n100: "失敗",
      n101: "區號",
      n102: "接收手機號",
      n103: "消耗金額",
      n104: "請再次輸入密碼",
      n105: "兩次密碼不一致",
      n106: "新密碼",
      n107: "請輸入關鍵字",
      n108: "請輸入谷歌密鑰",
      n109: "添加",
      n110: "關鍵詞",
      n111: "經度",
      n112: "緯度",
      n113: "修改",
      n114: "新增",
      n115: "谷歌密鑰：",
      n116: "條數",
      n117: "名稱",
      n118: "地址",
      n119: "電話",
      n120: "創建時間",
      n121: "數據查看",
      n122: "下載",
      n123: "採集中",
      n124: "成功",
      n125: "失敗",
      n126: "狀態",
      n127: "谷歌採集",
      n128: "請輸入內容",
      n129: "請選擇坐標",
      n130: "選點",
      n131: "查看",
      n132: "中心位置",
      n133: "確 定",
      n134: "選擇地圖位置",
      n135: "搜索地點",
      n136: "當前選中坐標",
      n137: "請輸入搜索關鍵詞",
      n138: "請選擇中心位置",
      n139: "未找到該地點，請嘗試其他關鍵詞",
      n140: "請先在地圖上選擇一個位置",
      n141: "下載失敗",
      n142: "下載成功",
      n143: "下載請求失敗"
    }
  },
  ...zhLocale
};
export default zh_TC;



// WEBPACK FOOTER //
// ./src/assets/i18n/langs/zh_TC.js